import ApiService from './ApiService';

const TasksService = {
  list: ({ status, assignee } = {}) => ApiService.get('/tasks', { status, assignee }),
  summary: () => ApiService.get('/tasks/summary'),
  create: (task) => ApiService.post('/tasks', task),
  update: (id, fields) => ApiService.patch(`/tasks/${id}`, fields),
};

export default TasksService;
